export default function ApprovePRAProcessController(
  $q,
  $scope,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.processLoaded = false;

  _activate();


  /** *************************************************
   * Event Handlers
   */

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on(
      'expandProcess',
      ($event, expandProcessArgs) => {
        if (
          vm.process.processId === expandProcessArgs.processId
          && (vm.process.functions && vm.process.functions.length > 0)
          && !vm.isEdit
        ) {
          vm.isExpanded = true;
        }
      }
    );
    $scope.$emit('processDirectiveEventsSet');
  }
}

ApprovePRAProcessController.$inject = [
  '$q',
  '$scope',
];
